export function LoadingSpinner({ size = 32 }: { size?: number }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        border: `${size / 8}px solid #e5e7eb`,
        borderTop: `${size / 8}px solid #ef4444`,
        borderRadius: "50%",
        animation: "spin 0.8s linear infinite",
      }}
    />
  );
}
